import type { EventTileCoordinates } from "../../models/randomEvent.ts";

export function pickRandomEventTile(
  candidates: readonly EventTileCoordinates[],
  exclude: EventTileCoordinates,
  random: () => number,
): EventTileCoordinates | null {
  const eligible = candidates.filter(
    (tile) => tile.q !== exclude.q || tile.r !== exclude.r,
  );

  if (eligible.length === 0) {
    return null;
  }

  const roll = random();
  const index =
    roll >= 1 ? eligible.length - 1 : Math.floor(roll * eligible.length);
  return eligible[index] ?? null;
}
